import {FormattedMessage, IntlShape} from 'react-intl';
import {Equipped} from '.cache/__types__';

export const translations = {
    [Equipped.Undefined]: <FormattedMessage defaultMessage="Nevyplněno" />,
    [Equipped.Nevybaveny]: <FormattedMessage defaultMessage="Nevybaveno" />,
    [Equipped.Castecne]: <FormattedMessage defaultMessage="Částečně" />,
    [Equipped.Vybaveny]: <FormattedMessage defaultMessage="Vybaveno" />,
};

export const translationsString = {
    [Equipped.Undefined]: (intl: IntlShape) => intl.formatMessage({defaultMessage: 'Nevyplněno'}),
    [Equipped.Nevybaveny]: (intl: IntlShape) => intl.formatMessage({defaultMessage: 'Nevybaveno'}),
    [Equipped.Castecne]: (intl: IntlShape) => intl.formatMessage({defaultMessage: 'Částečně'}),
    [Equipped.Vybaveny]: (intl: IntlShape) => intl.formatMessage({defaultMessage: 'Vybaveno'}),
};

export const getTranslationString = (intl: IntlShape, key: Equipped) => translationsString[key](intl);

export const label = <FormattedMessage defaultMessage="Zařízení" />;
